import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "divide-y divide-gray-200" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "group-hover:text-white text-indigo-500"
}
const _hoisted_6 = { class: "group-hover:text-indigo-200 text-gray-500 mt-2" }

import { PropType } from "@vue/runtime-core";
import { CheckIcon } from "@heroicons/vue/solid";


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {},

  items: {
    type: Array as PropType<any[]>,
  },

  getKey: Function as PropType<(item: any) => string>,
  getTitle: Function as PropType<(item: any) => string>,
  getDescription: Function as PropType<
    (item: any) => string | null | undefined
  >,
},
  setup(__props) {

const props = __props



const title = (item: any) => {
  if (props.getTitle) return props.getTitle(item);
  return item?.title;
};

const description = (item: any) => {
  if (props.getDescription) return props.getDescription(item);
  return item?.description;
};

const key = (item: any) => {
  if (props.getKey) return props.getKey(item);
  return item?.id;
};

const isSelected = (item: any) => {
  if (!props.modelValue) return false;

  return key(props.modelValue) === key(item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
      return (_openBlock(), _createElementBlock("li", {
        key: key(item),
        class: _normalizeClass(["select-none relative p-4 text-sm group hover:bg-indigo-500 hover:text-white", [isSelected(item) ? 'cursor-default' : 'cursor-pointer']]),
        onClick: ($event: any) => (_ctx.$emit('update:modelValue', item))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", {
              class: _normalizeClass(isSelected(item) ? 'font-semibold' : 'font-normal')
            }, _toDisplayString(title(item)), 3),
            (isSelected(item))
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createVNode(_unref(CheckIcon), {
                    class: "h-5 w-5",
                    "aria-hidden": "true"
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(description(item)), 1)
        ])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})